<ng-template #content let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Client Document</h4>
        <button type="button" #closebtn class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <form [formGroup]="docForm" (ngSubmit)="saveDocument()">
            <div class="form-body">
                <div class="row mb-3">
                    <div class="col-lg-6">
                        <label>Document Type</label>
                        <div class="input-group">
                            <select class="form-control" formControlName="doc_type" >
                                <option *ngFor="let item of docTypes" value="{{item.id}}">{{item.lookup_name}}</option>
                            </select>
                        </div>
                    </div>
                     <div class="col-lg-6">
                        <label>File</label>
                        <div class="input-group">
                            <input id="fancy-file-upload" class="form-control" type="file" formControlName="client_file" accept=".jpg, .png, image/jpeg, image/png">
                        </div>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-lg-6 ">
                        <label>File Comment</label>
                        <div class="input-group">
                            <textarea  class="form-control" formControlName="file_comment" ></textarea>
                        </div>
                        </div>                
                </div>
                <div class="row">
                     <div class="input-group">
                        <button [disabled]="docForm.invalid" type="submit" class="btn btn-primary">Save</button>
                    </div>
                    <span [ngClass]="errorclass" >{{errormessage}}</span>
                </div>
            </div>
        </form>
    </div>
</ng-template>